module.exports = __webpack_public_path__ + "static/media/chat_avatar.a0d4983c.svg";